
<div class="upload-component">
    <div class="photo-upload">
        <div class="button-and-text">
            @if (uploadingFile) {
            <span>Uploading file now. Depending on how large the file is and your internet
                connection, it may take a while. If it takes longer than a few minutes, try again later.</span>
            }
            @if (uploadError?.permittedSize > 0) {
            <span class="warning-message">
                The file you uploaded is {{formatBytesToMB(uploadError?.actualSize)}} MB. The maximum
                size allowed is {{formatBytesToMB(uploadError?.permittedSize)}} MB
            </span>
            }
            @if (uploadError && uploadError?.permittedSize <= 0) { <span class="warning-message">
                Their was an error while upload your file, please try again later. If the problem
                persists, please contact support.
                </span>
                }
                <label for="file-upload" class="custom-file-upload">
                    <i class="fa fa-cloud-upload"></i>Upload
                </label>
                <input id="file-upload" type="file" multiple (change)="fileSelected($event)"
                    accept=".jpg,.jpeg,.png,.pdf">
                <div>
                    We recommend a 360x360px PNG or JPG.
                </div>
        </div>
    </div>
</div>